<template>
  <v-container fluid class="full-container config-container">
    <v-row class="tabs-root">
      <v-toolbar flat fixed class="tabs-toolbar">
        <v-tabs
          v-model="tab"
          grow
          show-arrows
        >
          <v-tabs-slider/>
          <v-tab :href="`#${tabs()[0]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.config.pages.app.icon }}</v-icon>
            {{ lang.meta.pages.config.pages.app.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[1]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.config.pages.themes.icon }}</v-icon>
            {{ lang.meta.pages.config.pages.themes.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[2]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.config.pages.permissions.icon }}</v-icon>
            {{ lang.meta.pages.config.pages.permissions.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[3]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.config.pages.defaults.icon }}</v-icon>
            {{ lang.meta.pages.config.pages.defaults.title }}
          </v-tab>
        </v-tabs>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-row>
    <v-row class="blank-toolbar"> </v-row>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-tabs-items v-model="tab">
          <v-tab-item :id="tabs()[0]">
            <App />
          </v-tab-item>
          <v-tab-item :id="tabs()[1]">
            <Themes />
          </v-tab-item>
          <v-tab-item :id="tabs()[2]">
            <Permissions />
          </v-tab-item>
          <v-tab-item :id="tabs()[3]">
            <Defaults />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import App from '@/components/config/app/App'
import Themes from '@/components/config/themes/Themes'
import Permissions from '@/components/config/permissions/Permissions'
import Defaults from '@/components/config/defaults/Defaults'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import tabs from '@/mixins/defaults/tabs'

export default {
  components: { App, Themes, Permissions, Defaults },
  mixins: [ appdata, utils, tabs ],
  data () {
    return {
      tabs: function () {
        return [
          this.lang.meta.pages.config.pages.app.path,
          this.lang.meta.pages.config.pages.themes.path,
          this.lang.meta.pages.config.pages.permissions.path,
          this.lang.meta.pages.config.pages.defaults.path
        ]
      }
    }
  }
}
</script>

<style src="@/components/config/styles/index.scss" lang="scss"></style>
